<template>
  <div class="video-player">
    <div v-show="showPoster" class="video-player__poster-container">
      <button class="video-player__poster-play" @click="startVideo">
        <oie-use-svg svg="play" :height="40" :width="40"></oie-use-svg>
      </button>
      <oie-base-image
        :images="posterImage"
        alt-text="Placeholder image for paused video"
        class="video-player__poster"
        @click.native="startVideo"></oie-base-image>
    </div>
    <div v-show="!showPoster" class="video-player__video">
      <div ref="playerElement"></div>
      <button
        v-if="cloudflareId"
        v-show="playing"
        class="video-player__control-btn"
        :aria-label="'Pause video'"
        @click="toggleVideo(false)">
        <oie-use-svg svg="pause" :height="40" :width="40"></oie-use-svg>
      </button>
      <button
        v-if="cloudflareId"
        v-show="!playing"
        class="video-player__control-btn"
        :aria-label="'Play video'"
        @click="toggleVideo(true)">
        <oie-use-svg svg="play" :height="40" :width="40"></oie-use-svg>
      </button>
    </div>
  </div>
</template>

<script>
import { createYoutubePlayer, createCloudflarePlayer } from '@/core/video-service'

export default {
  props: {
    youtubeId: { type: String, required: false, default: '' },
    cloudflareId: { type: String, required: false, default: '' },
    posterImage: { type: String, required: false, default: 'https://placehold.co/384x384/FF4646/white' },
    options: { type: Object, required: false, default: () => ({}) }
  },
  data() {
    return {
      player: null,
      showPoster: true,
      playing: false
    }
  },
  mounted() {
    this.subscribe('pause-video', () => {
      if(this.player) {
        this.player.pause()
      }
    })
  },
  methods: {
    async startVideo() {
      this.showPoster = false
      if(this.cloudflareId) {
        const playerOptions = {
          muted: true,
          ...this.options
        }
        this.player = await createCloudflarePlayer(this.$refs.playerElement, this.cloudflareId, playerOptions)
        this.player.play()
        this.playing = true
      } else if(this.youtubeId) {
        this.player = await createYoutubePlayer(this.$refs.playerElement, this.youtubeId)
        this.player.play()
        this.playing = true
      }
    },
    toggleVideo(play) {
      this.playing = play
      if(play) {
        this.player.play()
      } else {
        this.player.pause()
      }
    }
  }
}
</script>

<style lang="scss">
.video-player {
  position: relative;
}

.video-player__poster-container {
  position: relative;
}

.video-player__poster-play {
  @include reset-button;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.video-player__poster {
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9;
  margin: 0 auto;
}

.video-player__video {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  position: relative;
  display: flex;
}

.video-player__video > div {
  width: 100%;
}

.video-player__video iframe{
  width: 100%;
  max-width: 720px;
}

.video-player__control-btn {
  @include reset-button;
  position: absolute;
  bottom: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
}

</style>
